function getStickyAddToCartForm() {
    return document.querySelector(
        ".customize-product-sticky-form form[action*='/cart/add'][data-type='add-to-cart-form']"
    );
}

function isSubscriptionPurchaseSelected() {
    const radio = document.querySelector('#purchaseTypeSubscription');
    if (radio) return radio.checked;
    const label = document.querySelector('label[for="purchaseTypeSubscription"]');
    return Boolean(label && label.classList.contains('is-selected'));
}

function getSelectedSellingPlanId() {
    const dropdown = document.querySelector(
        '.stayai-subscription-dropdown, .rtx-subscription-dropdown'
    );
    if (dropdown && dropdown.value) return dropdown.value;

    const mainInput = document.querySelector(
        ".product__info-container input[name='selling_plan'], .product__info-wrapper input[name='selling_plan']"
    );
    return (mainInput && mainInput.value) || '';
}

function ensureStickySellingPlanInput(productForm) {
    let sellingPlanInput = productForm.querySelector("input[name='selling_plan']");
    if (!sellingPlanInput) {
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        productForm.appendChild(sellingPlanInput);
    }
    return sellingPlanInput;
}

function syncSubscriptionToSticky() {
    const productForm = getStickyAddToCartForm();
    const priceEl = document.querySelector('.product-sticky-form__price');
    if (!productForm || !priceEl) return;

    const sellingPlanInput = ensureStickySellingPlanInput(productForm);

    if (isSubscriptionPurchaseSelected()) {
        sellingPlanInput.value = getSelectedSellingPlanId();
        const priceSub = document.querySelector(
            '[data-stayai-subscription-price], [data-rtx-subscription-price]'
        );
        if (priceSub) {
            priceEl.replaceChildren(priceSub.cloneNode(true));
        }
    } else {
        sellingPlanInput.value = '';
        const priceOneTime = document.querySelector(
            '[data-stayai-onetime-price], [data-rtx-onetime-price]'
        );
        if (priceOneTime) {
            priceEl.textContent = priceOneTime.textContent.trim();
        }
    }
}

function scheduleStickySubscriptionSync() {
    syncSubscriptionToSticky();
    setTimeout(syncSubscriptionToSticky, 50);
    setTimeout(syncSubscriptionToSticky, 400);
}

function initStickySubscriptionSync() {
    if (window.__stickySubscriptionSyncInit) return;
    window.__stickySubscriptionSyncInit = true;

    document.addEventListener('change', (event) => {
        if (
            event.target.matches(
                "#purchaseTypeSubscription, #purchaseTypeOneTime, input[name='purchaseType'], .stayai-subscription-dropdown, .rtx-subscription-dropdown"
            )
        ) {
            scheduleStickySubscriptionSync();
        }
    });

    document.addEventListener('click', (event) => {
        if (
            event.target.closest(
                ".stayai-purchase-label, .rtx-purchase-label, label[for='purchaseTypeSubscription'], label[for='purchaseTypeOneTime']"
            )
        ) {
            scheduleStickySubscriptionSync();
        }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, scheduleStickySubscriptionSync);
    }

    scheduleStickySubscriptionSync();
}

class customizeStickyForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        let buttonSticky = document.querySelector('.customize-product-sticky-form');
        let addToCartButton = document.querySelector('.product__info-wrapper .product-form__buttons');
        // init sync
        setTimeout(() => {
            this.syncWithMainSelector();
            this.updateStickyVariantAvailability();
            this.setupVariantSync();
            this.setupStickyToMainSync();
            initStickySubscriptionSync();
        }, 100);
        if (window.innerWidth > 768) {
            buttonSticky.classList.add('is-sticky-below', 'is-sticky');
            buttonSticky.classList.remove('is-sticky-above', 'sticky-add-hidden');
        } else {
            buttonSticky.classList.add('is-sticky-mobile');
            buttonSticky.classList.remove('sticky-add-hidden');
        }

        window.addEventListener('scroll', () => {
            // Nothing to track against if the main CTA is missing; bail rather
            // than throw on every scroll event.
            if (!addToCartButton) return;
            const rect = addToCartButton.getBoundingClientRect();
            const isMobile = window.innerWidth < 768;

            if (isMobile) {
                if (addToCartButton) {
                const inViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;

                if (!inViewport) {
                    buttonSticky.classList.add('is-sticky-mobile');
                    buttonSticky.classList.remove('sticky-add-hidden');

                } else {
                    buttonSticky.classList.remove('is-sticky-mobile');
                    buttonSticky.classList.add('sticky-add-hidden');
                    this.closeAllStickyDropdowns();
                }
            }
            } else {

                    if (window.scrollY === 0) {
                        // Đang ở trên cùng trang, không thể scroll lên nữa
                        buttonSticky.classList.add('is-sticky-below', 'is-sticky');
                        buttonSticky.classList.remove('is-sticky-above', 'sticky-add-hidden');
                    } else if (rect.bottom < 0) {
                        // Button đã trôi lên trên viewport (user scroll xuống dưới)
                        buttonSticky.classList.add('is-sticky-above', 'is-sticky');
                        buttonSticky.classList.remove('is-sticky-below', 'sticky-add-hidden');
                    } else if (rect.top > window.innerHeight) {
                        // Button nằm dưới viewport (user scroll lên trên nhưng chưa tới top)
                        buttonSticky.classList.add('is-sticky-below', 'is-sticky');
                        buttonSticky.classList.remove('is-sticky-above', 'sticky-add-hidden');
                    } else {
                        // Button trong viewport
                        buttonSticky.classList.remove('is-sticky-above', 'is-sticky-below', 'is-sticky');
                        buttonSticky.classList.add('sticky-add-hidden');
                        this.closeAllStickyDropdowns();
                    }
            }
        });
    }

    getOffsetTop(addToCartButton) {
        const rect = addToCartButton.getBoundingClientRect();
        return rect.top + window.scrollY;
    }

    syncWithMainSelector() {
        const stickyCustomSelects = this.querySelectorAll('customize-custom-select');
        if (!stickyCustomSelects.length) return;

        const optionValues = this.getMainOptionValues();
        if (!optionValues.length) return;

        optionValues.forEach((value, index) => {
            const stickyCustom = stickyCustomSelects[index];
            if (!stickyCustom) return;
            const stickySelect = stickyCustom.querySelector('select');
            const appendValue = stickyCustom.querySelector('.append-value');
            if (stickySelect && value != null && stickySelect.value !== value) {
                stickySelect.value = value;
                stickySelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (appendValue && value != null) {
                appendValue.textContent = `: ${value}`;
            }
        });

        scheduleStickySubscriptionSync();

        this.updateStickyVariantAvailability();
    }

    getMainOptionValues() {
        const values = [];
        const variantSelects = document.querySelector('.product__info-wrapper variant-selects');
        const variantRadios = document.querySelector('.product__info-wrapper variant-radios');

        if (variantSelects) {
            const selects = variantSelects.querySelectorAll('select');
            selects.forEach((select) => values.push(select.value));
            return values;
        }
        if (variantRadios) {
            const fieldsets = variantRadios.querySelectorAll('fieldset');
            fieldsets.forEach((fs) => {
                const checked = fs.querySelector('input[type="radio"]:checked');
                values.push(checked ? checked.value : null);
            });
            return values;
        }
        return values;
    }

    getStickyOptionValues() {
        const values = [];
        const stickyCustomSelects = this.querySelectorAll('customize-custom-select');
        if (!stickyCustomSelects.length) return values;

        stickyCustomSelects.forEach((customEl) => {
            const select = customEl.querySelector('select');
            values.push(select ? select.value : null);
        });
        return values;
    }

    syncToMainSelector() {
        const values = this.getStickyOptionValues();
        if (!values.length) return;

        const variantSelects = document.querySelector('.product__info-wrapper variant-selects');
        const variantRadios = document.querySelector('.product__info-wrapper variant-radios');

        if (variantSelects) {
            const selects = variantSelects.querySelectorAll('select');
            values.forEach((value, index) => {
                const mainSelect = selects[index];
                if (!mainSelect || value == null) return;
                if (mainSelect.value !== value) {
                    mainSelect.value = value;
                }
                mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
            });
            return;
        }

        if (variantRadios) {
            const fieldsets = variantRadios.querySelectorAll('fieldset');
            values.forEach((value, index) => {
                const fs = fieldsets[index];
                if (!fs || value == null) return;
                const radio = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
                if (radio) {
                    if (!radio.checked) radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }
    }

    setupVariantSync() {
        const variantSelects = document.querySelector('.product__info-wrapper variant-selects');
        const variantRadios = document.querySelector('.product__info-wrapper variant-radios');
        if (variantSelects) {
            variantSelects.addEventListener('change', (e) => {
                if (e.target && e.target.tagName === 'SELECT') {
                    this.syncWithMainSelector();
                    this.updateStickyVariantAvailability();
                }
            });
        }
        if (variantRadios) {
            variantRadios.addEventListener('change', (e) => {
                if (e.target && e.target.matches('input[type="radio"]')) {
                    this.syncWithMainSelector();
                    this.updateStickyVariantAvailability();
                }
            });
        }
    }

    setupStickyToMainSync() {
        const stickySelects = this.querySelectorAll('customize-custom-select select');
        if (!stickySelects.length) return;
        stickySelects.forEach((select) => {
            select.addEventListener('change', () => {
                this.syncToMainSelector();
            });
        });
    }

    updateStickyVariantAvailability() {
        const stickyCustomSelects = this.querySelectorAll('customize-custom-select');
        if (!stickyCustomSelects.length) return;

        const variantDataScript = this.querySelector('script[type="application/json"]');
        if (!variantDataScript) return;

        const variantData = JSON.parse(variantDataScript.textContent);
        const currentValues = this.getMainOptionValues();

        stickyCustomSelects.forEach((customSelect, optionIndex) => {
            const customizeSelectValues = customSelect.querySelectorAll('.customize-select-value');

            customizeSelectValues.forEach((selectValue) => {
                const optionValue = selectValue.getAttribute('value');
                let isAvailable = false;

                for (const variant of variantData) {
                    let matches = true;

                    for (let i = 0; i < optionIndex; i++) {
                        if (currentValues[i] && variant[`option${i + 1}`] !== currentValues[i]) {
                            matches = false;
                            break;
                        }
                    }

                    if (matches && variant[`option${optionIndex + 1}`] === optionValue && variant.available) {
                        isAvailable = true;
                        break;
                    }
                }

                if (isAvailable) {
                    selectValue.classList.remove('disabled');
                } else {
                    selectValue.classList.add('disabled');
                }
            });
        });
    }

    closeAllStickyDropdowns() {
        const openCustoms = this.querySelectorAll('customize-custom-select.active');
        openCustoms.forEach((el) => el.classList.remove('active'));
        const openDropdowns = this.querySelectorAll('.product-form__input--dropdown.active');
        openDropdowns.forEach((el) => el.classList.remove('active'));
    }
}

customElements.define('product-sticky-form', customizeStickyForm);

class customizeCustomSelect extends HTMLElement {
    constructor() {
        super();
        this.self = this;
        this.btns = this.querySelectorAll('.customize-select-value');
        this.selectEl = this.querySelector('select');
        this.dropdown = this.querySelector('.product-form__input--dropdown');
        this.querySelector('.customize-custom-select__label').addEventListener('click', () => {
            const dropdownActive = document.querySelector('.product-form__input--dropdown.active');
            if (dropdownActive && dropdownActive !== this.self) {
                dropdownActive.classList.remove('active');
            }
            this.self.classList.toggle('active');
        });
        if (this.btns) {
            this.btns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    const value = event.currentTarget.getAttribute('value');
                    this.self.querySelector('.append-value').innerHTML = `: ${value}`;
                    this.selectEl.value = value;
                    const changeEvent = new Event('change', { bubbles: true });
                    this.selectEl.dispatchEvent(changeEvent);
                    this.self.classList.remove('active');
                });
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', initStickySubscriptionSync);

